import { z } from "zod";
import stringSchema from "@/lib/utils/stringSchema";


const formSchema = z.object({
  resource_name: z.string(),
  resource_email: z.string(),
  resource_count: z.union([z.number(), z.string()]),
  bamboo_id: z.union([z.number(), z.string()]),
  service_type_id: z.union([z.number(), z.string()]),
  resource_role: z.string().optional().nullable(),
  resource_external_role: z.string().optional().nullable(),
  resource_rate: z.union([z.number(), z.string()]),
  number_of_month: z.union([z.number(), z.string()]),
  monthly_hours: z.union([z.number(), z.string()]),
  resource_agreed_hours: z.union([z.number(), z.string()]),
  resource_total_amount: z.union([z.number(), z.string()]),
  service_level: stringSchema({ key: "Service Level", required: true }),
  resource_start_date: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date().optional().nullable()),
  resource_end_date: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date().optional().nullable()),
  periods: z.array(
    z.object({
      rate: z.string().optional().nullable(),
      hours: z.string().optional().nullable(),
      maand: z.string().optional().nullable(),
    })
  ).optional().nullable(),
});

export default formSchema;